import * as THREE from "three";
import { envMap, glassAlpha, glassColor, glassNormal, groundColor, groundNormal, groundRoughness, insulatedSprite, panelNormal, threeAxisLedAlpha, threeAxisLedAlphaRotated, wallColor, wallNormal, wallRoughness, zipNormal } from "./assets/materials";
export function createRenderer(canvasElement) {
    const renderer = new THREE.WebGLRenderer({ antialias: true, canvas: canvasElement, preserveDrawingBuffer: true });
    renderer.setSize(canvasElement.clientWidth, canvasElement.clientHeight, false);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setClearColor(0x051E2E);
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.autoUpdate = true;
    //renderer.toneMapping = THREE.ReinhardToneMapping
    renderer.autoClear = false;
    groundNormal.anisotropy = renderer.capabilities.getMaxAnisotropy();
    groundRoughness.anisotropy = renderer.capabilities.getMaxAnisotropy();
    groundColor.anisotropy = renderer.capabilities.getMaxAnisotropy();
    wallColor.anisotropy = renderer.capabilities.getMaxAnisotropy();
    wallNormal.anisotropy = renderer.capabilities.getMaxAnisotropy();
    wallRoughness.anisotropy = renderer.capabilities.getMaxAnisotropy();
    panelNormal.anisotropy = renderer.capabilities.getMaxAnisotropy();
    envMap.anisotropy = renderer.capabilities.getMaxAnisotropy();
    glassAlpha.anisotropy = renderer.capabilities.getMaxAnisotropy();
    glassNormal.anisotropy = renderer.capabilities.getMaxAnisotropy();
    glassColor.anisotropy = renderer.capabilities.getMaxAnisotropy();
    zipNormal.anisotropy = renderer.capabilities.getMaxAnisotropy();
    insulatedSprite.anisotropy = renderer.capabilities.getMaxAnisotropy();
    threeAxisLedAlpha.anisotropy = renderer.capabilities.getMaxAnisotropy();
    threeAxisLedAlphaRotated.anisotropy = renderer.capabilities.getMaxAnisotropy();
    return renderer;
}
